import { getShadowStyle, pxToRelative, pxToRems } from '@awaze/design-system.utils.react';
import styled, { css } from 'styled-components';
export const SearchSummaryWrapStyled = styled.button `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${pxToRems(12)};
  border: none;
  border-radius: ${({ isFloating }) => isFloating && pxToRems(4)};
  cursor: pointer;
  text-align: left;
  line-height: ${({ theme }) => pxToRelative(theme.FontTextText300LineHeight)};
  background: ${({ theme }) => theme.ColorWhiteOpacity100};

  ${({ theme, isFloating }) => isFloating &&
    css `
      box-shadow: ${getShadowStyle({ theme, depth: 4 })};
    `}

  > button {
    pointer-events: none;
  }
`;
export const HintTextStyled = styled.p `
  margin: 0;

  ${({ theme }) => css `
      font-size: ${pxToRems(theme.FontTextText100FontSize)};
      line-height: ${pxToRems(theme.FontTextText100LineHeight)};
      color: ${theme.ColorGrey800};
    `}
`;
export const LocationTextStyled = styled.p `
  margin: 0;
  color: ${({ theme }) => theme.ColorGrey800};
`;
export const SearchPlaceholderStyled = styled.p `
  margin: 0;

  ${({ theme }) => css `
      color: ${theme.ColorGrey400};
    `}
`;
export const DetailSummaryStyled = styled.p `
  display: flex;
  align-items: center;
  margin: 0;

  ${({ theme }) => css `
      font-size: ${pxToRems(theme.FontTextText100FontSize)};
      line-height: ${pxToRems(theme.FontTextText100LineHeight)};
      color: ${theme.ColorGrey800};
    `}

  > svg {
    margin-right: ${pxToRems(4)};
  }
`;
//# sourceMappingURL=search-summary.styles.js.map